var Backbone = require('backbone');
Backbone.$ = window.$ = window.jQuery = require('jquery');
require('jquery-validation');

var Marionette = require('backbone.marionette');
var ich = require('icanhaz').ich;

Marionette.Renderer.render = function (template, data) {
  if (template) {
    return ich[template](data);
  }
};

const clientGlobals = require('../../../client_cw_globals');
const { initDDrum, startLogging } = require('../../utils/ddRumUtils');

// init logging
if (clientGlobals.ddRumApplicationId && clientGlobals.ddRumClientToken) {
  initDDrum(`classwallet@${window.appVersion}`);
  startLogging();
}

Number.prototype.formatMoney = function (c, d, t) {
  var n = this,
    c = isNaN((c = Math.abs(c))) ? 2 : c,
    d = d == undefined ? '.' : d,
    t = t == undefined ? ',' : t,
    s = n < 0 ? '-' : '',
    i = parseInt((n = Math.abs(+n || 0).toFixed(c))) + '',
    j = (j = i.length) > 3 ? j % 3 : 0;
  return (
    s +
    (j ? i.substr(0, j) + t : '') +
    i.substr(j).replace(/(\d{3})(?=\d)/g, '$1' + t) +
    (c
      ? d +
        Math.abs(n - i)
          .toFixed(c)
          .slice(2)
      : '')
  );
};
